var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"LoginCopyright"},[_c('p',[_vm._v("Copyright © Telestrada S.A. "+_vm._s(_vm.props.year))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5db790","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginCopyright/index.vue
// module id = 1309
// module chunks = 3